import { TextField, Button, Typography, Stack, Grid, Divider } from '@mui/material';
import { useState } from 'react';
import { UserInfo } from '../../hooks/useUserInfo';

interface Props {
  onClose: () => void;
  userInfo: UserInfo | undefined;
  updateUserInfo: (oldPassword: string, newPassword: string, newNickname: string) => Promise<void>;
}

export default function UserDetails({ onClose, userInfo, updateUserInfo } : Props) {
  const [newNickname, setNewNickname] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await updateUserInfo(oldPassword, newPassword, newNickname);
      onClose(); // close the modal
    } catch (error) {
      console.error(error);
    }
  };

  return <>
    <Grid container spacing={1}>
      <Grid item xs={3}>
	<Typography variant="body1">Login ID:</Typography>
      </Grid>
      <Grid item xs={9}>
	<Typography variant="body1"><strong>{userInfo?.username}</strong></Typography>
      </Grid>
      
      <Grid item xs={3}>
	<Typography variant="body1">Screen name:</Typography>
      </Grid>
      <Grid item xs={9}>
	<Typography variant="body1"><strong>{userInfo?.nickname}</strong></Typography>
      </Grid>
    </Grid>

    <Divider sx={{ my: 2 }} /> {/* This adds top and bottom margins */}
    
    <form onSubmit={handleSubmit}>
      <Stack spacing={2}>
        <Typography variant="h6" component="h3">
	  Change screen name
        </Typography>

        <TextField
	  label="New screen name"
		 fullWidth
	  value={newNickname}
		 onChange={(e) => setNewNickname(e.target.value)}
        />
	
        <Typography variant="h6" component="h3">
	  Change password
        </Typography>
	
        <TextField
	  label="Old password"
		 type="password"
		 fullWidth
	  value={oldPassword}
		 onChange={(e) => setOldPassword(e.target.value)}
        />
	
        <TextField
	  label="New password"
		 type="password"
		 fullWidth
	  value={newPassword}
		 onChange={(e) => setNewPassword(e.target.value)}
        />
	
        <Button variant="contained" color="primary" type="submit">
	  Update my details
        </Button>
      </Stack>
    </form>
  </>;
}
